import NavigateRightUp from './src/navigate-right-up-combined';
export default NavigateRightUp;